import React from 'react';
import PropTypes from 'prop-types';
import { Container, Title, Note } from './styles';

function StepTitle({ title = '', note = '', isMobileDevice }) {
  return (
    <Container isMobileDevice={isMobileDevice} data-publi={`professionalPubli-stepTitle-container`}>
      <Title data-publi='professionalPubli-stepTitle-title'>{title}</Title>
      {note && <Note data-publi='professionalPubli-stepTitle-note'>{note}</Note>}
    </Container>
  );
}

StepTitle.propTypes = {
  title: PropTypes.string.isRequired,
  note: PropTypes.string,
  isMobileDevice: PropTypes.bool
};

export default StepTitle;
